import { ChevronRight } from 'lucide-react'
import PropTypes from 'prop-types'

import { AdasAccordion, AdasAccordionDetails, AdasAccordionSummary } from '@components/wrapper-components'

export const Accordion = ({ defaultExpanded, ...props }) => (
  <AdasAccordion defaultExpanded={defaultExpanded} className='rounded-xl border border-[#D1D5D8] bg-white' {...props} />
)

export const AccordionSummary = (props) => (
  <AdasAccordionSummary
    expandIcon={<ChevronRight className='w-4 h-4' />}
    className='flex-row-reverse gap-2 rounded-xl bg-white px-4 py-3 hover:bg-[#F8FAFC]'
    {...props}
  />
)

export const AccordionDetails = AdasAccordionDetails

Accordion.propTypes = {
  defaultExpanded: PropTypes.bool
}
